export const CATEGORY_OPTIONS = [
  { value: 'bug', label: 'Bug' },
  { value: 'suggestion', label: 'Sugerencia' },
  { value: 'roadmap', label: 'Roadmap' },
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Baja' },
  { value: 'medium', label: 'Media' },
  { value: 'high', label: 'Alta' },
  { value: 'critical', label: 'Critica' },
];

export const STATUS_OPTIONS = [
  { value: 'new', label: 'Nuevo' },
  { value: 'triaged', label: 'Triage' },
  { value: 'planned', label: 'Planificado' },
  { value: 'in_progress', label: 'En curso' },
  { value: 'done', label: 'Completado' },
  { value: 'rejected', label: 'Descartado' },
];

/**
 * Quién abrió un ticket, en algo legible.
 *
 * El backend guarda ahora el correo (o el nombre, si el token lo trae). Los
 * tickets viejos guardaron el id del usuario, y el listado pide al backend que
 * lo traduzca con el directorio del IdP: ese nombre llega en `created_by_name`.
 */
export function autorLegible(valor) {
  const texto = String(valor || '').trim();
  if (!texto) return 'Sin registrar';
  if (/^\d+$/.test(texto)) return `usuario #${texto}`;
  return texto;
}

/**
 * El nombre del autor de un ticket, usando el que resuelve el backend desde el
 * directorio del IdP (`created_by_name` / `updated_by_name`).
 *
 * Sin esto, un ticket de ayer salía como «usuario #1»: el id del IdP no dice
 * nada, y el CMDB no guarda la tabla de usuarios.
 */
export function nombreAutor(ticket, campo = 'created_by') {
  const resuelto = ticket?.[`${campo}_name`];
  if (resuelto) return resuelto;
  return autorLegible(ticket?.[campo]);
}

/**
 * El usuario de la sesión (correo y nombre si los hay).
 *
 * Lo usa el alta de tickets para decir a quién se le va a apuntar el ticket: el
 * backend lo registra solo, a partir del token, pero más vale decirlo en pantalla
 * que dejar al usuario preguntándose de dónde sale.
 */
export function usuarioActual() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return {
      nombre: user.name || user.full_name || '',
      email: user.email || '',
      // La opción «privado» (un ticket que solo ve la empresa que lo abre) es
      // solo para el superadmin de plataforma: las empresas cliente nunca
      // crean tickets privados.
      superadmin: Boolean(user.is_superadmin),
    };
  } catch {
    return { nombre: '', email: '', superadmin: false };
  }
}

export const statusLabel = (value) => STATUS_OPTIONS.find((s) => s.value === value)?.label || value;
export const categoryLabel = (value) => CATEGORY_OPTIONS.find((c) => c.value === value)?.label || value;
export const priorityLabel = (value) => PRIORITY_OPTIONS.find((p) => p.value === value)?.label || value;
